<template>
    <div>
        <Header>
            <template v-slot:menu_center>
                <p class="menu_center_tex_l top_tit">HACCP STATION</p>
            </template>
        </Header>
        <ErrorPanel
                :title="this.title"
                :code="this.code"
                :message="this.message"
                :button-path="this.path"
                :button-text="this.text"
                :can-back="this.canBack"
        />
    </div>
</template>

<script>
    import Header from '@/app/components/Header.vue'
    import ErrorPanel from '@/app/components/ErrorPanel.vue'
    export default {
        name: 'Error',
        components: {
            Header,
            ErrorPanel,
        },
        computed: {
            title: function () {
                return this.$store.getters['error/title']
            },
            message: function () {
                return this.$store.getters['error/message']
            },
            code: function () {
                return this.$store.getters['error/errorCode']
            },
            path: function () {
                return this.$store.getters['error/buttonPath']
            },
            text: function () {
                return this.$store.getters['error/buttonText']
            },
            canBack: function () {
                return this.$store.getters['error/canBack']
            }
        },
        beforeDestroy: function () {
            if (this.code == '1105-401' || this.code == '1103-403') {
                //店舗管理者のtokenエラーの場合
                this.$cookies.set('user-api-token', '', 0)
                this.$store.dispatch('store/doClear')
            }
            this.$store.dispatch('error/clearError')
        }
    }
</script>
